import { useEffect, useRef, useState } from "react";
import {
  FaFacebook,
  FaInstagram,
  FaYoutube,
  FaSpotify,
  FaTiktok,
  FaSoundcloud,
} from "react-icons/fa";
import { SiThreads } from "react-icons/si";
import { FiCheck, FiCopy } from "react-icons/fi";
import { ARTIST_LINKS, CONTACT_EMAIL } from "../../data/artist";
import { track } from "../../utils/analytics";

// Icon for each platform (brand colors come from data/artist.js)
const ICONS = {
  facebook: FaFacebook,
  instagram: FaInstagram,
  youtube: FaYoutube,
  spotify: FaSpotify,
  tiktok: FaTiktok,
  threads: SiThreads,
  soundcloud: FaSoundcloud,
};

/*
 * The Contact tab of the info panel (InfoPanel.js): the email (with a copy
 * button) and the follow links.
 */
function ContactTab() {
  const [copied, setCopied] = useState(false);
  const timerRef = useRef(null);

  useEffect(() => () => clearTimeout(timerRef.current), []);

  const copyEmail = async () => {
    try {
      await navigator.clipboard.writeText(CONTACT_EMAIL);
      track("contact_email", { method: "copy" });
      setCopied(true);
      clearTimeout(timerRef.current);
      timerRef.current = setTimeout(() => setCopied(false), 2000);
    } catch {
      // Clipboard blocked: the email is still visible and clickable
    }
  };

  return (
    <>
      {CONTACT_EMAIL ? (
        <div className="contact-email-row">
          <a
            className="contact-email"
            href={`mailto:${CONTACT_EMAIL}`}
            onClick={() => track("contact_email", { method: "mailto" })}
          >
            {CONTACT_EMAIL}
          </a>
          <button className="contact-copy" onClick={copyEmail} aria-live="polite">
            {copied ? <FiCheck /> : <FiCopy />}
            <span>{copied ? "Copied" : "Copy"}</span>
          </button>
        </div>
      ) : null}

      <h3 className="contact-label contact-label--links">Follow</h3>
      <nav className="contact-links" aria-label="thangcao on social media">
        {ARTIST_LINKS.map(({ key, name, handle, href, color, glow }) => {
          const Icon = ICONS[key];
          return (
            <a
              key={key}
              className={`contact-link ${glow ? "is-glow" : ""}`}
              style={{ "--brand": color || "#fff" }}
              href={href}
              target="_blank"
              rel="noopener noreferrer"
              title={`${name} · ${handle}`}
              aria-label={`${name}, ${handle}`}
              onClick={() => track("social_click", { platform: key, place: "contact" })}
            >
              {Icon ? <Icon /> : name}
            </a>
          );
        })}
      </nav>
    </>
  );
}

export default ContactTab;
